//React
import { useState, useEffect, useRef } from 'react';

//System
import { register, getState } from '../../system/stateManager';

//System Helpers
import { performBack } from '../../helpers/backButton';

//Config
import { iwdPath } from '../../config';

//Styles
import './styles.css';

//Events

//Components
const buildTooltip = item => {
	let tooltip = item.name;
	if (item.quantity > 1) {
		tooltip += ` (${item.quantity})`;
	}

	const addStats = (stats, prefix = '') => {
		if (!stats)
			return;
		if (Array.isArray(stats)) {
			stats.forEach(s => {
				tooltip += `\n${prefix}${s.stat}: ${s.value}`;
			});
		} else {
			Object.entries(stats).forEach(([stat, value]) => {
				tooltip += `\n${prefix}${stat}: ${value}`;
			});
		}
	};

	addStats(item.stats);
	addStats(item.infusedStats, 'Infused ');
	addStats(item.enchantedStats, 'Enchanted ');
	addStats(item.implicitStats, 'Implicit ');

	return tooltip;
};

const ItemsList = ({ items }) => {
	const [tooltip, setTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

	const res = items.map((item, i) => {
		const key = `item-${i}`;

		const root = `${iwdPath}/images`;

		let spritesheet = item.spritesheet || `${root}/items.png`;
		if (!item.spritesheet) {
			if (item.material)
				spritesheet = `${root}/materials.png`;
			else if (item.quest)
				spritesheet = `${root}/questItems.png`;
			else if (item.type === 'consumable')
				spritesheet = `${root}/consumables.png`;
			else if (item.type === 'skin')
				spritesheet = `${root}/characters.png`;
		}

		const imgX = (-item.sprite[0] * 64);
		const imgY = (-item.sprite[1] * 64);

		const backgroundPosition = `${imgX}px ${imgY}px`;
		const style = {
			background: `url(${spritesheet}) no-repeat scroll ${backgroundPosition} / auto`,
			width: '64px',
			height: '64px'
		};

		const eq = item.eq ? <div className='eq'>eq</div> : null;
		const quantity = ~~item.quantity > 1 ? <div className='quantity'>{item.quantity}</div> : null;

		return (
			<div
				key={key}
				className='item'
				onMouseEnter={(e) => setTooltip({ visible: true, text: buildTooltip(item), x: e.clientX, y: e.clientY })}
				onMouseLeave={() => setTooltip({ visible: false })}
			>
				<div className='sprite' style={style} />
				{quantity}
				{eq}
			</div>
		);
	});

	return (
		<div className='itemsList'>
			{res}
			{tooltip.visible && (
				<div
					className='tooltip'
					style={{
						position: 'fixed',
						left: `${tooltip.x + 10}px`,
						top: `${tooltip.y + 10}px`,
						pointerEvents: 'none',
						zIndex: 1000
					}}
				>
					{tooltip.text}
				</div>
			)}
		</div>
	);
};

/* eslint-disable-next-line max-lines-per-function */
const Items = () => {
	const { items } = getState('inventory');

	if (!items)
		return null;

	const eqItems = items.filter(item => item.eq);
	const nonEqItems = items.filter(item => !item.eq);

	return (
		<div className='itemsContainer'>
			<div className='section'>
				<div className='sectionTitle'>Equipped</div>
				<div className='itemsList'>
					<ItemsList items={eqItems} />
				</div>
			</div>
			<div className='section'>
				<div className='sectionTitle'>Inventory</div>
				<div className='itemsList'>
					<ItemsList items={nonEqItems} />
				</div>
			</div>
		</div>
	);
};

const Inventory = () => {
	const [state, setter] = useState({ vis: false });

	const { vis, title } = state;

	useEffect(register.bind(null, 'inventory', setter, state), []);

	if (!vis)
		return;

	return (
		<div className='cpnInventory centered'>
			<div className='title'>
				{title}
			</div>
			<div className='bottom'>
				<Items />
			</div>
			<div className='toolbar'>
				<div className='btn gray' onClick={performBack}>Back</div>
			</div>
		</div>
	);
};

export default Inventory;
